<template>
	<div>
		<row>
			<c-col cols="8">
				<v-card>
					<v-card-title class="justify-space-between">
						<div class="ml-3">
              <b style="padding-left: 5px"> {{ $t("pages.orderTable.orderNum") }}: </b>
              <span>{{ item.orders_order_num }}</span>
            </div>
					</v-card-title>
					<v-card-title>
						<b style="padding-left: 5px"> {{ $t("pages.statusSelect") }}: </b>
						<span :class="styleIsDone">{{ status }}</span>
					</v-card-title>
					<v-card-title v-if="item.status_description">
						<b style="padding-left: 5px"> {{ $t("pages.measurementExpended.reason") }}: </b>
						<span class="note pre-notes">{{ item.status_description }}</span>
					</v-card-title>
					<v-card-title v-if="item.surveyor_private_msg">
						<b style="padding-left: 5px;font-size: 14px"> {{ $t("pages.cancelReasons.PrivateMsg") }}:
							<span>{{ item.surveyor_private_msg }}</span></b>
					</v-card-title>
				</v-card>
			</c-col>
			<c-col cols="4">
				<v-card>
					<v-card-title>פעולות
					</v-card-title>
					<v-card-actions>
            <v-btn v-if="item.images_directory" small color="primary" target="_blank" :href="'files/' + item.id " >
              הורדת קבצי מדידה
              <v-icon>mdi-download</v-icon>
            </v-btn>
						<gallery-dialog v-if="item.area_image && item.area_image.length" :images="item.area_image">
							<template slot="btn-title">תמונות מהמקום</template>
						</gallery-dialog>
						<v-btn @click="forceRemove" v-if="canForceDelete" color="error" dark>מחיקה לחלוטין</v-btn>
					</v-card-actions>
				</v-card>
			</c-col>
		</row>
		<row>
			<c-col>
				<v-card height="100%">
					<v-list dense>
						<v-list-item>
							<v-list-item-content><b>{{ $t("pages.orderTable.companyName") }}:</b></v-list-item-content>
							<v-list-item-content class="align-end">
								{{ item.projects_client_name }}
							</v-list-item-content>
						</v-list-item>
						<v-list-item v-if="!isSurveyor">
							<v-list-item-content><b>{{ $t("pages.projectForm.branch") }}:</b></v-list-item-content>
							<v-list-item-content class="align-end">
								{{ item.projects_branch_name }}
							</v-list-item-content>
						</v-list-item>
						<v-list-item v-if="isAdmin">
							<v-list-item-content><b>{{ $t("pages.measurementExpended.createdBy") }}:</b>
							</v-list-item-content>
							<v-list-item-content class="align-end">
								{{ item.creators_name }}
							</v-list-item-content>
						</v-list-item>
						<v-list-item>
							<v-list-item-content><b>{{ $t("pages.measurementTable.mustSurvey") }}:</b>
							</v-list-item-content>
							<v-list-item-content class="align-end">
								{{ item.areas }}
							</v-list-item-content>
						</v-list-item>
						<v-list-item>
							<v-list-item-content><b>{{ $t("pages.orderTable.tel") }}:</b></v-list-item-content>
							<v-list-item-content class="align-end">
								<whatsapp-link v-if="item.orders_customer_phone" :tel="item.orders_customer_phone"/>
							</v-list-item-content>
						</v-list-item>
						<v-list-item>
							<v-list-item-content><b>{{ $t("pages.orderTable.designer") }}:</b></v-list-item-content>
							<v-list-item-content class="align-end">
								{{ item.orders_designer }}
							</v-list-item-content>
						</v-list-item>
						<v-list-item>
							<v-list-item-content><b>{{ $t("pages.orderTable.designerPhone") }}:</b>
							</v-list-item-content>
							<v-list-item-content class="align-end">
								<whatsapp-link v-if="item.orders_designer_phone" :tel="item.orders_designer_phone"/>
							</v-list-item-content>
						</v-list-item>
					</v-list>
				</v-card>
			</c-col>
			<c-col>
				<v-card height="100%">
					<v-list dense>
						<v-list-item>
							<v-list-item-content><b>{{ $t("pages.projectForm.projectName") }}</b></v-list-item-content>
							<v-list-item-content class="align-end">
								{{ item.projects_name }}
							</v-list-item-content>
						</v-list-item>
						<v-list-item>
							<v-list-item-content><b>{{ $t("pages.projectForm.address") }}:</b></v-list-item-content>
							<v-list-item-content class="align-start">
								<!--								{{item.projects_address}}-->
								<waze-link :address="item.projects_address" :waze=fullAddress></waze-link>
							</v-list-item-content>
						</v-list-item>

						<v-list-item>
							<v-list-item-content><b>{{ $t("pages.orderForm.building") }}:</b></v-list-item-content>
							<v-list-item-content class="align-start">
								<span>{{ item.orders_building }}</span>
							</v-list-item-content>
						</v-list-item>
						<v-list-item>
							<v-list-item-content><b>{{ $t("pages.orderForm.entrance") }}:</b></v-list-item-content>
							<v-list-item-content class="align-start">
								<span>{{ item.orders_entrance }}</span>
							</v-list-item-content>
						</v-list-item>
						<v-list-item>
							<v-list-item-content><b>{{ $t("pages.orderForm.apartmentNum") }}:</b></v-list-item-content>
							<v-list-item-content class="align-end">
								{{ item.order_apartment_num }}
							</v-list-item-content>
						</v-list-item>
						<v-list-item>
							<v-list-item-content><b>{{ $t("pages.orderForm.floor") }}:</b></v-list-item-content>
							<v-list-item-content class="align-end">
								{{ item.order_apartment_floor }}
							</v-list-item-content>
						</v-list-item>

					</v-list>
				</v-card>
			</c-col>
			<c-col v-if="!isCloset">
				<v-card height="100%">
					<v-list dense>
						<v-list-item>
							<v-list-item-content>
								<span>
									<strong>{{ $t("pages.measurementForm.checkPlaster.yes") }}</strong>
									<yes-no :val="item.has_plaster"/>
								</span>
							</v-list-item-content>
						</v-list-item>
						<v-list-item v-if="!item.has_plaster">
							<v-list-item-content>
								<span>
									<strong>{{ $t("pages.measurementForm.checkPlaster.ifNot") }}</strong>
									<yes-no :val="item.confirm_plaster"/>
								</span>
							</v-list-item-content>
						</v-list-item>
						<v-divider></v-divider>
						<v-list-item>
							<v-list-item-content>
								<span>
									<strong>{{ $t("pages.measurementForm.checkFlooring") }}</strong>
									<yes-no :val="item.has_floor"/>
								</span>
							</v-list-item-content>

						</v-list-item>
						<v-list-item v-if="!item.has_floor">
							<v-list-item-content>
								<span>
									<strong>{{ $t("pages.measurementForm.checkPlaster.ifNot") }}:
									</strong>
									<yes-no :val="item.confirm_floor"/>
								</span>
							</v-list-item-content>

						</v-list-item>

						<v-divider></v-divider>
						<v-list-item>
							<v-list-item-content>
								<span>
									<strong>{{ $t("pages.measurementForm.checkElecticity") }}:</strong>
									<yes-no :val="item.has_electric"/>
								</span>
							</v-list-item-content>

						</v-list-item>

						<v-list-item>
							<v-list-item-content v-if="!item.has_electric">
								<span>
									<strong>{{ $t("pages.measurementForm.checkPlaster.ifNot") }}:</strong>
									<yes-no :val="item.confirm_electric"/>
								</span>
							</v-list-item-content>

						</v-list-item>

					</v-list>
				</v-card>
			</c-col>
			<c-col v-if="isCloset">
				<v-card height="100%">

					<v-list-item>
						<v-list-item-content><b>{{ $t("closet.name") }}:</b></v-list-item-content>
						<v-list-item-content class="align-end">
							{{ item.closet_name }}
						</v-list-item-content>
					</v-list-item>

					<v-list-item>
						<v-list-item-content><b>{{ $t("closet.room") }}:</b></v-list-item-content>
						<v-list-item-content class="align-end">
							{{ item.room }}
						</v-list-item-content>
					</v-list-item>

					<v-list-item>
						<v-list-item-content><b>{{ $t("closet.size") }}:</b></v-list-item-content>
						<v-list-item-content class="align-end">
							{{ item.size }}
						</v-list-item-content>
					</v-list-item>

					<v-list-item>
						<v-list-item-content><b>{{ $t("closet.door_size") }}:</b></v-list-item-content>
						<v-list-item-content class="align-end">
							{{ item.door_size }}
						</v-list-item-content>
					</v-list-item>

					<v-list-item>
						<v-list-item-content><b>{{ $t("closet.note") }}:</b></v-list-item-content>
						<v-list-item-content class="align-start" >
							<p class="pre-notes" > {{ item.note }}</p>

						</v-list-item-content>
					</v-list-item>
				</v-card>
			</c-col>
			<c-col v-if="(item.projects_name == this.$t('attributes.private'))">
				<v-card height="100%">
					<v-list dense>
						<v-list-item>
							<v-list-item-content><b>{{ $t("pages.orderTable.tel") }}:</b></v-list-item-content>
							<v-list-item-content>
								<whatsapp-link :tel="item.orders_customer_phone"/>
							</v-list-item-content>
						</v-list-item>
					</v-list>
					<v-list dense>
						<v-list-item>
							<v-list-item-content><b>{{ $t('pages.projectForm.contact') }}:</b></v-list-item-content>
							<v-list-item-content class="align-end" style="color:red">
								{{ item.orders_contact_name }}
							</v-list-item-content>
						</v-list-item>
					</v-list>
					<v-divider></v-divider>
					<v-list dense>
						<v-list-item>
							<v-list-item-content><b>{{ $t("pages.orderTable.tel2") }}:</b></v-list-item-content>
							<v-list-item-content>
								<whatsapp-link :tel="item.orders_tel2"/>
							</v-list-item-content>
						</v-list-item>
					</v-list>
					<v-list dense>
						<v-list-item>
							<v-list-item-content><b>{{ $t('pages.projectForm.contact') }}:</b></v-list-item-content>
							<v-list-item-content class="align-end" style="color:red">
								{{ item.orders_contact2_tel }}
							</v-list-item-content>
						</v-list-item>
					</v-list>
					<v-divider v-if="item.orders_is_outside" ></v-divider>
					<v-list v-if="item.orders_is_outside" dense>
						<v-list-item>
							<v-list-item-content><b>דוא"ל:</b></v-list-item-content>
							<v-list-item-content class="align-end">
								<a :href="`mailto:${item.orders_email}`" target="_blank">{{ item.orders_email }}</a>
							</v-list-item-content>
						</v-list-item>
					</v-list>
					<v-list v-if="item.orders_is_outside" dense>
						<v-list-item>
							<v-list-item-content><b>תעודת זהות</b></v-list-item-content>
							<v-list-item-content class="align-end" style="color:red">
								{{ item.orders_id_number }}
							</v-list-item-content>
						</v-list-item>
					</v-list>
					<v-list dense v-if="item.accepted_by">
						<v-list-item>
							<v-list-item-content><b>{{ $t("acceptedBy.accepted") }}:</b></v-list-item-content>
							<v-list-item-content class="align-end" style="color:red">
								{{item.accepted_by === "customer" ?$t("acceptedBy.customer") : $t("acceptedBy.company") }}
							</v-list-item-content>
						</v-list-item>

					</v-list>
				</v-card>
			</c-col>
			<c-col v-if="!(item.projects_name==this.$t('attributes.private'))">
				<v-card height="100%">
					<v-list dense>
						<v-list dense>
							<v-list-item>
								<v-list-item-content><b>{{ $t("pages.projectForm.contact") }}</b></v-list-item-content>
								<v-list-item-content class="align-end">
									{{ item.projects_contact }}
								</v-list-item-content>
							</v-list-item>
							<v-list-item>
								<v-list-item-content v-if="item.projects_contact_tel"><b>{{ $t("pages.orderTable.tel") }}:</b>
								</v-list-item-content>
								<whatsapp-link :tel="item.projects_contact_tel"/>
							</v-list-item>
						</v-list>

						<v-list dense>
							<v-list-item>
								<v-list-item-content><b>{{ $t("pages.orderConsForm.secondContact") }}</b>
								</v-list-item-content>
								<v-list-item-content class="align-end">
									{{ item.projects_contact2 }}
								</v-list-item-content>
							</v-list-item>
							<v-list-item v-if="item.projects_contact2_tel">
								<v-list-item-content>
									<b>{{ $t("pages.orderTable.tel") + " " + $t("pages.orderConsForm.secondContact")
									}}:</b>
								</v-list-item-content>
								<whatsapp-link :tel="item.projects_contact2_tel"/>
							</v-list-item>
						</v-list>

						<v-list dense>
							<v-list-item>
								<v-list-item-content><b>{{ $t("pages.orderConsForm.thirdContact") }}</b>
								</v-list-item-content>
								<v-list-item-content class="align-end">
									{{ item.projects_contact3 }}
								</v-list-item-content>
							</v-list-item>
							<v-list-item v-if="item.projects_contact3_tel">
								<v-list-item-content><b>{{
									$t("pages.orderTable.tel") + " " + $t("pages.orderConsForm.thirdContact")
								}}</b></v-list-item-content>
								<whatsapp-link :tel="item.projects_contact3_tel"/>
							</v-list-item>
						</v-list>
					</v-list>
					<v-list dense v-if="item.accepted_by">
						<v-list-item>
							<v-list-item-content><b>{{ $t("acceptedBy.accepted") }}:</b></v-list-item-content>
							<v-list-item-content class="align-end" style="color:red">
								{{item.accepted_by === "customer" ?$t("acceptedBy.customer") : $t("acceptedBy.company") }}
							</v-list-item-content>
						</v-list-item>
					</v-list>

				</v-card>
			</c-col>
			<c-col>
				<v-card height="100%">
					<v-list dense>
						<v-list-item v-if="!isClient && !isSurveyor">
							<c-btn small text :tooltip-text="$t('dialog.match.internalNote')" @click="editInternalNote">
								<v-icon>mdi-pencil</v-icon>
							</c-btn>
							<v-list-item-content><b>{{ $t("dialog.match.internalNote") }}:</b>
								<span v-if="item.internal_note" class="note pre-notes">{{ item.internal_note }} </span>
							</v-list-item-content>

						</v-list-item>

						<v-list-item v-if="!isSurveyor">
							<c-btn v-if="isManager" small text :tooltip-text="$t('dialog.match.clientNote')"
								@click="editClientNote">
								<v-icon>mdi-pencil</v-icon>
							</c-btn>
							<v-list-item-content><b>{{ $t("dialog.match.clientNote") }}:</b>
								<div v-if="item.client_note" class="note pre-notes">{{ item.client_note }}</div>
							</v-list-item-content>

						</v-list-item>
            <v-list-item v-if="isAdmin">
              <c-btn small text tooltip-text="תוספת מחיר" @click="editAdditionalPrice">
                <v-icon>mdi-pencil</v-icon>
              </c-btn>
              <v-list-item-content><b>תוספת מחיר</b>
                <span v-if="item.additional_price" class="note pre-notes">{{ item.additional_price }} </span>
              </v-list-item-content>

            </v-list-item>

						<v-list-item v-if="isCoordinated && (isSurveyor || isManager)">
							<c-btn v-if="isManager && isCoordinated" small text
								:tooltip-text="$t('dialog.match.noteToMatch')"
								@click="editCoordinatedNote">
								<v-icon>mdi-pencil</v-icon>
							</c-btn>
							<v-list-item-content><b>{{ $t("dialog.match.noteToMatch") }}:</b>
								<span class="note pre-notes">	{{ item.coordinated_note }} </span>
							</v-list-item-content>

						</v-list-item>
						<v-divider v-if="item.coordinated_note"/>

						<v-list-item class="align-start" v-if="item.note">
							<b>{{ $t("pages.orderTable.note") }}:</b>
							<v-list-item-content class="align-start px-1">
								<p class="align-center pre-notes" style="color:red">{{ item.note }}</p>
							</v-list-item-content>
						</v-list-item>
						<v-divider v-if="item.note"/>

						<v-list-item v-if="item.surveyor_notes && isManager">
							<v-list-item-content>
								<b>{{ $t("pages.orderTable.note") + " " + $t("pages.measurementTable.surveyer") }}
									:</b>
								<p class="note pre-notes">{{ item.surveyor_notes }}</p>
							</v-list-item-content>
						</v-list-item>
						<v-divider v-if="item.surveyor_notes"/>
						<v-list-item v-if="item.recheck_note">

							<v-list-item-content>
								<b>{{ $t("pages.measurementExpended.noteWhyAgian") }}:</b>
								<p class="note pre-notes"> {{ item.recheck_note ? item.recheck_note : "" }}
								</p>
							</v-list-item-content>
						</v-list-item>
						<v-divider v-if="item.recheck_note"/>
						<v-list-item v-if="item.recheck_surveyor_note">
							<v-list-item-content >
								<b>{{ $t("pages.measurementExpended.noteWhyAgian") + " - " + $t("pages.measurementTable.surveyer") }}:</b>
								<p class="note pre-notes">	{{ item.recheck_surveyor_note }}</p>
							</v-list-item-content>
						</v-list-item>

					</v-list>
				</v-card>
			</c-col>
		</row>

		<row>
			<div>
				<table style="padding-right:10px ">
					<tr v-if="!(item.projects_name==this.$t('attributes.private'))">

					</tr>
				</table>
			</div>
		</row>

		<row>
			<c-col>
				<v-card>
					<v-list>
						<v-subheader>
							<span v-if="item.files && item.files.length">{{ $t("pages.measurementExpended.files") }}:</span>
							<span v-else>{{ $t("pages.measurementExpended.noFiles") }}</span>
						</v-subheader>
						<v-list-item-group color="primary">
							<v-list-item
								v-for="file in item.files"
								:key="file.id"
								:href="'/storage/measurement/'+file.src" target="_blank"
							>
								<v-list-item-content>
									<v-list-item-title v-text="file.original_name"></v-list-item-title>
								</v-list-item-content>
							</v-list-item>
						</v-list-item-group>
					</v-list>
				</v-card>
			</c-col>
		</row>
	</div>
</template>

<script>
	import {types as measurementTypes} from "src/store/modules/Measurement.module";
	import StatusManager, {types as statusTypes} from "dev/helpers/StatusManager";
	import WhatsappLink from "dev/view/measurements/WhatsappLink";
	import YesNo from "dev/view/measurements/YesNo";
	import CBtn from "dev/scaffoldings/CBtn";
	import WazeLink from "dev/view/measurements/WazeLink";
	import GalleryDialog from "../../components/GalleryDialog";

	export default {
		name: "measurement-expended",
		components: {GalleryDialog, WazeLink, CBtn, YesNo, WhatsappLink},
		props: ["item", "headers"],
		methods: {
			async editClientNote() {

				let def = {
					title: this.$t("dialog.match.clientNote"),
					showCancelButton: true,
					confirmButtonText: this.$t("attributes.save"),
					confirmButtonColor: "#3085d6",
					cancelButtonColor: "#d33",
					cancelButtonText: this.$t("attributes.cancel")
				};
				def.input = "textarea";
				def.inputPlaceholder = this.$t("dialog.match.clientNote");
				def.inputValue = this.item.client_note && this.item.client_note + "\n";
				let {value} = await swal.fire(Object.assign(def));
				this.item.client_note = value;

				await this.$store.dispatch(measurementTypes.UPDATE, this.item);
			},

			async editInternalNote() {

				let def = {
					title: this.$t("dialog.match.internalNote"),
					showCancelButton: true,
					confirmButtonText: this.$t("attributes.save"),
					confirmButtonColor: "#3085d6",
					cancelButtonColor: "#d33",
					cancelButtonText: this.$t("attributes.cancel")
				};
				def.input = "textarea";
				def.inputPlaceholder = this.$t("dialog.match.internalNote");
				def.inputValue = this.item.internal_note && this.item.internal_note + "\n";
				let {value} = await swal.fire(Object.assign(def));
				this.item.internal_note = value;

				await this.$store.dispatch(measurementTypes.UPDATE, this.item);
			},
      async editAdditionalPrice() {

				let def = {
					title: "תוספת מחיר",
					showCancelButton: true,
					confirmButtonText: this.$t("attributes.save"),
					confirmButtonColor: "#3085d6",
					cancelButtonColor: "#d33",
					cancelButtonText: this.$t("attributes.cancel")
				};
				def.input = "text";
				def.inputPlaceholder = "טקסט חופשי לתוספת מחיר";
				def.inputValue = this.item.additional_price && this.item.additional_price + "\n";
				let {value} = await swal.fire(Object.assign(def));
				this.item.additional_price = value;

				await this.$store.dispatch(measurementTypes.UPDATE, this.item);
			},
			async forceRemove() {
				let {value} = await this.$notfication.warning("האם אתה בטוח?", "לא ניתן לשחזר את המידע שימחק!");
				if (value) {
					this.$store.dispatch(measurementTypes.FORCE_REMOVE, this.item);
				}
			},
			async editCoordinatedNote() {

				let def = {
					title: this.$t("dialog.match.noteToMatch"),
					showCancelButton: true,
					confirmButtonText: this.$t("attributes.save"),
					confirmButtonColor: "#3085d6",
					cancelButtonColor: "#d33",
					cancelButtonText: this.$t("attributes.cancel")
				};
				def.input = "textarea";
				def.inputPlaceholder = this.$t("dialog.match.noteToMatch");
				def.inputValue = this.item.coordinated_note && this.item.coordinated_note + "\n";
				let {value} = await swal.fire(Object.assign(def));
				const m = Object.assign({},this.item, {coordinated_note : value});
				await this.$store.dispatch(measurementTypes.UPDATE, this.item);
			}

		},
		computed: {

			styleIsDone() {
				if (this.isDone) {
					return "note";
				} else
					return "";
			},
			isDone() {
				return (this.item.status === statusTypes.DONE || this.item.status === statusTypes.DO_AGAIN);
			},

			isCloset() {
				let areas = this.item.areas || "";
				return areas.includes(this.$t("pages.measurmentArea.Cabinet")) || areas === this.$t("pages.measurmentArea.wall");
			},

			isCoordinated() {
				return this.item.status == statusTypes.COORDINATED;
			},

			isClient() {
				return this.$store.getters.isClient;
			},
			isAdmin() {
				return this.$store.getters.isAdmin;
			},

			isManager() {
				return this.$store.getters.isManager;
			},

			canForceDelete() {
				return (this.isManager && [null, 0, 1, 2, 5].indexOf(this.item.status) > -1);
			},

			isSurveyor() {
				return this.$store.getters.isSurveyor;
			},
			status() {
				return StatusManager.text(this.item.status);
			},
			fullAddress() {
				if (this.item.projects_building) {
					return this.item.projects_address + " " + this.item.projects_building + " " + this.item.projects_city;
				} else {
					return this.item.projects_address + " " + this.item.orders_building + " " + this.item.projects_city;
				}

			}
		},
	};
</script>

<style scoped>

    thead > tr > th.text-start {
        padding: 1px;
        justify-content: center !important;
        child-align: middle !important;
    }

    .v-card__title {
        padding: 5px;
        padding-right: 10px;
    }

    .align-end {
        text-align: center;
    }

    span {
        alignment: center;
    }

    .note {
      color: red;
      font-weight: bold;
      background-color: yellow;
      white-space: pre-line;
    }

    .pre-notes{
      white-space: pre-line;
      max-height: 100px;
      overflow-y: auto;
    }


</style>
